import { api } from "@/lib/api";

const TOKEN_KEY = "vl_admin_token";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

function authHeaders() {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function adminLogin(passcode) {
    const { data } = await api.post("/admin/login", { passcode });
    setToken(data.token);
    return data;
}

export async function adminLogout() {
    try {
        await api.post("/admin/logout", null, { headers: authHeaders() });
    } catch (_) {
        // ignore
    }
    setToken("");
}

export async function adminFetchLeads(leadType) {
    const params = leadType && leadType !== "all" ? { lead_type: leadType } : {};
    const { data } = await api.get("/admin/leads", { headers: authHeaders(), params });
    return data;
}

export async function adminFetchStats() {
    const { data } = await api.get("/admin/stats", { headers: authHeaders() });
    return data;
}

export async function adminUpdateLeadStatus(leadId, status) {
    const { data } = await api.patch(`/admin/leads/${leadId}`, { status }, { headers: authHeaders() });
    return data;
}

export async function adminDeleteLead(leadId) {
    const { data } = await api.delete(`/admin/leads/${leadId}`, { headers: authHeaders() });
    return data;
}

export function adminCsvExportUrl(leadType) {
    const base = `${api.defaults.baseURL}/admin/leads/export`;
    const qs = leadType && leadType !== "all" ? `?lead_type=${encodeURIComponent(leadType)}` : "";
    return base + qs;
}

export async function adminDownloadCsv(leadType) {
    const res = await api.get("/admin/leads/export", {
        headers: authHeaders(),
        params: leadType && leadType !== "all" ? { lead_type: leadType } : {},
        responseType: "blob",
    });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    const cd = res.headers["content-disposition"] || "";
    const m = cd.match(/filename="([^"]+)"/);
    a.download = m ? m[1] : `vibhuti_leads_${leadType || "all"}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}

// ----------------------------- Jobs -----------------------------
export async function adminFetchJobs() {
    const { data } = await api.get("/admin/jobs", { headers: authHeaders() });
    return data;
}

export async function adminCreateJob(job) {
    const { data } = await api.post("/admin/jobs", job, { headers: authHeaders() });
    return data;
}

export async function adminUpdateJob(jobId, update) {
    const { data } = await api.patch(`/admin/jobs/${jobId}`, update, { headers: authHeaders() });
    return data;
}

export async function adminDeleteJob(jobId) {
    const { data } = await api.delete(`/admin/jobs/${jobId}`, { headers: authHeaders() });
    return data;
}

export async function adminGenerateJD({ title, experience, location, type }) {
    const { data } = await api.post(
        "/admin/jobs/generate-description",
        { title, experience, location, type },
        { headers: authHeaders() }
    );
    return data;
}
